import React, { useEffect, useRef, useCallback } from "react"
import { Thread, ConversationItems } from "../../../../types"
import ThreadItem from "../thread-item"

interface Props {
  conversation: ConversationItems
  thread: Thread
  onResize: () => void
}

const ThreadItemList = React.memo<Props>(
  ({ conversation, thread, onResize }: Props) => {
    const wrapperRef = useRef<HTMLDivElement>(null)

    // Memoize the resize callback to prevent unnecessary observer re-creation
    const handleResize = useCallback(() => {
      onResize()
    }, [onResize])

    // Use ResizeObserver to observe changes in the container's size (e.g., image loading)
    useEffect(() => {
      const scrollContainer = wrapperRef.current
      const observer = new ResizeObserver(handleResize)

      if (scrollContainer) {
        observer.observe(scrollContainer)
      }

      return () => {
        if (scrollContainer) {
          observer.unobserve(scrollContainer)
        }
      }
    }, [handleResize])

    return (
      <div
        ref={wrapperRef}
        className="px-4 md:px-8 py-4 flex flex-col lg:max-w-[800px] lg:mx-auto"
      >
        {conversation.map((item, index) => (
          <ThreadItem
            conversation={conversation}
            key={item._id}
            item={item}
            thread={thread}
            index={index}
          />
        ))}
      </div>
    )
  }
)

ThreadItemList.displayName = "ThreadItemList"

export default ThreadItemList
